import { ReconciliationDashboardRepository } from '../repositories/reconciliation-dashboard.repository';
import { ReconciliationDashboardRepositoryService } from '../repositories/reconciliation-dashboard.service';

export const ReconciliationDashboardProvider = [
  {
    provide: ReconciliationDashboardRepository,
    useClass: ReconciliationDashboardRepositoryService,
  },
];
